import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PipesModule } from 'app/shared/pipes/pipes.module';
import { SharedModule } from 'app/shared/shared.module';
import { NgxPaginationModule } from 'ngx-pagination';
import {
  PaymentRequestAuditTrailComponent
} from './payment-request-information/payment-request-audit-trail/payment-request-audit-trail.component';
import {
  PaymentRequestDetailsComponent
} from './payment-request-information/payment-request-details/payment-request-details.component';
import {
  PaymentRequestInformationComponent
} from './payment-request-information/payment-request-information/payment-request-information.component';
import { PaymentRequestUrlComponent } from './payment-request-url/payment-request-url.component';
import { PaymentRequestComponent } from './payment-request/payment-request.component';
import { PaymentRequestsListComponent } from './payment-requests-list/payment-requests-list.component';
import { PaymentRequestsRoutingModule } from './payment-requests-routing.module';

@NgModule({
  imports: [
    CommonModule,
    PaymentRequestsRoutingModule,
    NgxPaginationModule,
    SharedModule,
    PipesModule
  ],
  declarations: [
    PaymentRequestsListComponent,
    PaymentRequestComponent,
    PaymentRequestInformationComponent,
    PaymentRequestDetailsComponent,
    PaymentRequestAuditTrailComponent,
    PaymentRequestUrlComponent
  ],
  entryComponents: [
    PaymentRequestComponent,
    PaymentRequestInformationComponent,
    PaymentRequestUrlComponent
  ]
})
export class PaymentRequestsModule {
}
